import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { deleteRoom } from '../../../../actions/userActions';
import AdminDeleteRoomView from '../../../../containers/ChatRooms/Room/Admin/Room/AdminDeleteRoom';
const AdminDeleteRoom = ({ match }) => {
   // const { roomRequests } = useSelector(state => state.userInfo)
    const dispatch = useDispatch()
    const deleteRoomFn = ()=>{
        dispatch(deleteRoom(match.params.idRoom))
    }
  return (
      <AdminDeleteRoomView deleteRoom={deleteRoomFn}/>
  )
};

export default AdminDeleteRoom;
